import { render } from "./SinglePart.vue?vue&type=template&id=33b67d66"
import script from "./SinglePart.vue?vue&type=script&lang=js"
export * from "./SinglePart.vue?vue&type=script&lang=js"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__